<mat-toolbar class="topbar">
  <button mat-icon-button type="button" (click)="backToAdmin()" title="Back to Admin">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <button mat-button type="button" (click)="goHome()">Career Challenges</button>
  <span class="spacer"></span>
</mat-toolbar>

<main class="shell-body">
  <router-outlet></router-outlet>
</main>
